{
  "McpApiUrl": "https://mcp.api.synoptic.com",
  "AppUrl": "https://synoptic.com",
  "TerminalHostedZoneName": "terminal.synoptic.com",
  "Graph2Endpoint": "graph2.synoptic.com",
  "ApiEndpoint": "api.synoptic.com",
  "UserPoolClientId": "2fo3s8cs18vq05f4fn9v548bg5",
  "UserPoolEndpoint": "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_XAL8vU0YX",
  "UserPoolId": "us-east-1_XAL8vU0YX",
  "PageScreenshotLambdaUrl": "https://44n6pggoz2mixypajci23vyma40buply.lambda-url.us-east-1.on.aws/",
  "MediaServiceBucketName": "media.synoptic.com",
  "MediaServiceDomainName": "media.synoptic.com",
  "PriceProxyUrl": "https://price-proxy.synoptic.com"
}